<template>
  <div class="chart-panel panel">
    <Spin v-if="showLoading" fix />
    <div v-if="refreshable" class="chart-panel-toolbox">
      <Icon type="md-refresh" @click.stop="loadData()" />
    </div>
    <div class="chart-panel-body">
      <v-chart ref="charts" :auto-resize="true" :options="options" :loading="loading" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartPanel',
  props: {
    refreshable: {
      type: Boolean,
      default: false
    },
    apiContextPath: {
      type: String,
      default: ''
    },
    chartHeight: {
      type: String,
      default: '400px'
    },
    title: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showLoading: this.loading
    }
  },
  watch: {
    options(val) {
    },
    loading: function(val) {
      this.showLoading = val
      if (this.showLoading) {
        this.loadData()
      }
    },
    chartHeight: function(val) {
      this.$refs.charts.resize()
    }
  },
  mounted() {
    const _this = this
    window.addEventListener('resize', function(event) {
      // this.$refs.countTo.resize()
      _this.$refs.charts.resize()
    })
  },
  methods: {
    loadData: function() {
      // this.showLoading = true
      // getStat(this.apiContextPath, {
      //   startDate: this.startDate,
      //   endDate: this.endDate,
      //   buildName: this.$store.getters.neSwId
      // }).then(res => {
      //   const { data } = res.data
      //   this.$emit('callback', this.options, data)
      //   this.$emit('onCompleteCallback', true)
      //   this.showLoading = false
      // }).catch(error => {
      //   console.log(error)
      //   this.$emit('onCompleteCallback', false)
      //   this.showLoading = false
      // })
    }
  }
}
</script>

<style lang="less" scoped>
  .echarts {
    width: 100%;
    height: 300px;
    // height: 100%;
  }
</style>
